/* eslint-disable import/no-unresolved */
import * as singleSpa from 'single-spa'
import * as isActive from './activityFns'

import { sendDatadogError } from './scenes/EngagementPlatform/services/datadog'

const appNames = ['vision2', 'pulse', 'hackersmind', 'reflex']

export function registerApps(services) {
  if (!singleSpa.getAppNames().some((app) => appNames.includes(app))) {
    const { vision_2, pulse, hackersmind, reflex, show_ui_vision, logindata } = services
    const uiVision = show_ui_vision
      ? [
          {
            appName: 'vision2',
            appFn: () => import('elevate_vision2'),
            activityFn: (location) => isActive.vision(location, vision_2),
            customProps: { logindata }
          }
        ]
      : []

    const appsList = [
      ...uiVision,

      {
        appName: 'pulse',
        appFn: () => import('elevate_pulse'),
        activityFn: (location) => isActive.pulse(location, pulse)
      },
      {
        appName: 'hackersmind',
        appFn: () => import('elevate_hackersmind'),
        activityFn: (location) => isActive.hackersmind(location, hackersmind)
      },
      {
        appName: 'reflex',
        appFn: () => import('elevate_reflex'),
        activityFn: (location) => isActive.reflex(location, reflex)
      }
    ]

    appsList.forEach(({ appName, appFn, activityFn, customProps }) => {
      singleSpa.registerApplication(appName, appFn, activityFn, customProps)
    })
  }
}

/** For public Vision routes */
export function registerVisionOnly(services) {
  if (!singleSpa.getAppNames().some((app) => ['vision2'].includes(app))) {
    singleSpa.registerApplication(
      'vision2',
      () => import('elevate_vision2'),
      (location) => isActive.vision(location, services.vision_2),
      { logindata: services?.logindata }
    )
  }
}

export function unregisterApp(appData) {
  try {
    if (singleSpa.getAppStatus(appData.appName) !== singleSpa.LOAD_ERROR) {
      singleSpa.unloadApplication(appData.appName, { waitForUnmount: false })
    }
  } catch (error) {
    sendDatadogError(`Encountered errors while trying to unload ${appData.appName}`, 'error', error)
  }
}
